/**
 * Created by Ning Jiang on 2021-05-27.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {BlitzKriegSound} from "../../sound/BlitzKriegSound";
import {DDay} from "../../DDay";
import {BlitzkriegSymbols, BlitzKriegSymbolState} from "../../symbol/DDaySymbolConfig";
import {BlitzKriegGameMode} from "../../server/BlitzKriegGameMode";

export class ReelStopSoundController extends ReelStopPresentationController {

    private _spinStates: boolean[];

    constructor() {
        super('ReelStopSoundController');
    }

    public async start(): Promise<any> {
        this._spinStates = DDay.reels.map(reel => reel.reelState === ReelState.SPIN);
        await super.start();
    }

    protected onReelBounce(data: IReelStateEventData): Promise<any> {
        BlitzKriegSound.playRandomReelStopSound(data.reelId);
        if (DDay.model.parsedGameData.nearWinReels[data.reelId]) {
            DDay.scatterAnticipation.stopScatterAnimation(data.reelId);
        }
        if (data.reelId < 4 && DDay.model.parsedGameData.nearWinReels[data.reelId + 1] && !this.isSkip) {
            DDay.scatterAnticipation.playScatterAnimation(data.reelId + 1);
        }

        if (data.reelId === 4) {
            let stopMeter: boolean = !(DDay.model.gameData.mode !== BlitzKriegGameMode.NORMAL && DDay.model.parsedGameData.featureInfo.length >= 0);
            DDay.reelBackground.resetRadioSignal(stopMeter);
        }
        this._spinStates[data.reelId] = false;
        if (this._spinStates.every(s => !s)) {
            BlitzKriegSound.stopTrack(BlitzKriegSound.REELS_SPINNING);
        }
        this.isWildExistOnReel(data);
        this.isScatterExistOnReel(data);
        return super.onReelBounce(data);
    }

    protected onReelStopped(data: IReelStateEventData): Promise<void> {
        if (DDay.model.parsedGameData.nearWinReels[data.reelId]) {
            let soundName: string = BlitzKriegSound.SCATTER_ANTICIPATION_LANDING.next();
            BlitzKriegSound.playTrackUsingDavidPanning(soundName, data.reelId);
        }
        return super.onReelStopped(data);
    }

    public skip(): void {
        super.skip();
        this.forceStopAnticipation();
    }

    public forceStopAnticipation(): void {
        DDay.model.parsedGameData.nearWinReels.forEach((nearWinReel: boolean, reelIdx: number) => {
            if (this.isSkip && nearWinReel) {
                DDay.scatterAnticipation.stopScatterAnimation(reelIdx);
            }
        });
    }

    private isWildExistOnReel(data: IReelStateEventData): void {
        let isWildExist: boolean = false;
        for (let i: number = 1; i < DDay.model.parsedGameData.reels[data.reelId].length - 1; i++) {
            if (DDay.model.parsedGameData.reels[data.reelId][i] === BlitzkriegSymbols.W) {
                isWildExist = true;
            }
        }
        if (isWildExist) {
            BlitzKriegSound.playTrack({name: BlitzKriegSound.WILD_LAND});
        }
    }

    private isScatterExistOnReel(data: IReelStateEventData): void {
        let isScatterExist: boolean = false;
        let previousScatterCount: number = 0;
        let scatterIdx: number = -1;
        for (let i: number = 1; i < DDay.model.parsedGameData.reels[data.reelId].length - 1; i++) {
            if (DDay.model.parsedGameData.reels[data.reelId][i] === BlitzkriegSymbols.S) {
                isScatterExist = true;
                scatterIdx = (i - 1);
            }
        }

        for (let reelId: number = 0; reelId <= data.reelId; reelId++) {
            for (let i: number = 1; i < DDay.model.parsedGameData.reels[reelId].length - 1; i++) {
                if (DDay.model.parsedGameData.reels[reelId][i] === BlitzkriegSymbols.S) {
                    previousScatterCount++;
                }
            }
        }
        if (isScatterExist) {
            if (data.reelId === 4 && previousScatterCount === 2) {
                BlitzKriegSound.playTrackUsingDavidPanning("scatterLandAtom", data.reelId);
            } else {
                BlitzKriegSound.playTrackUsingDavidPanning(("scatterLand" + previousScatterCount), data.reelId);
            }
            DDay.reels[data.reelId].getSymbol(scatterIdx).getStateAnimation(BlitzKriegSymbolState.LAND, {}, {}).play();
        }
    }
}
